class bike_packages {
  constructor() {
const WEBDOCBIKEINSDAILY1 = "WEBDOCBIKEINSDAILY1";
const WEBDOCBIKEINSDAILY2 = "WEBDOCBIKEINSDAILY2";
    this.items = [
      {
        serviceId: 1,
        pid: WEBDOCBIKEINSDAILY1,
        name: "WebdocBikeInsDaily1",
        serviceName:"Bike Insurance",
        badge: "Silver",
        coverage: "50,000",
        price:"6",
        bgColorClass: "bg-info",
        description: `<p><strong>Bike Insurance</strong> provides good value to Jazz customers who get financial protection in case of Bike Accidental damages.</p>
<ul>
<li><strong>Total Insurance Cover:</strong> PKR 50,000</li>
<li><strong>Accidental Bike Repair:</strong> Up to PKR 20,000</li>
<li><strong>Accidental Hospitalization:</strong> Up to PKR 30,000</li>
<li><strong>Waiting Period:</strong> 14 days</li>
</ul>
<p><strong>Claims</strong></p>
<ul>
<li>Make your claim within 30 days of the theft/burglary</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>Bike Repair receipt and / or police report to be provided</li>
</ul>
`,
          type: "rsa",
      },
      {
        serviceId: 2,
        pid: WEBDOCBIKEINSDAILY2,
        name: "WebdocBikeInsDaily2",
        serviceName:"Bike Insurance",
        badge: "Gold",
        coverage: "100,000",
        price:"12",
        bgColorClass: "bg-warning",
        description: `<p><strong>Bike Insurance</strong> provides good value to Jazz customers who get financial protection in case of Bike Accidental damages.</p>
<ul>
<li><strong>Total Insurance Cover:</strong> PKR 100,000</li>
<li><strong>Accidental Bike Repair:</strong> Up to PKR 40,000</li>
<li><strong>Accidental Hospitalization:</strong> Up to PKR 60,000</li>
<li><strong>Waiting Period:</strong> 14 days</li>
</ul>
<p><strong>Claims</strong></p>
<ul>
<li>Make your claim within 30 days of the theft/burglary</li>
<li>Settled directly with the claimants within 3 working days of document submission</li>
<li>Bike Repair receipt and / or police report to be provided</li>
</ul>`,
          type: "rsa",
      }
    ];
  }

  getAllItems() {
    return this.items;
  }
}

export default bike_packages;
